import filter from '@/rahmen/utils/filters'
import indexeddb from '@/ddv2.library/indexeddb'

export const msysTax = (state) => {
  return state.msystax
}

export const vwCMstTorihikisakiGetNyukinsaki = (state) => {
  return state.vwcmsttorihikisakigetnyukinsaki.map((m) => {
    m.tokuisakiFlgDisp = m.tokuisakiFlg ? '○' : ''
    m.shiiresakiFlgDisp = m.shiiresakiFlg ? '○' : ''
    m.hacchusakiFlgDisp = m.hacchusakiFlg ? '○' : ''
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.torihikisakiCd > b.torihikisakiCd) { return 1 }
    if (a.torihikisakiCd === b.torihikisakiCd) { return 0 }
    return -1
  })
}

export const vwCMstTorihikisakiGetShiharaisaki = (state) => {
  return state.vwcmsttorihikisakigetshiharaisaki.map((m) => {
    m.tokuisakiFlgDisp = m.tokuisakiFlg ? '○' : ''
    m.shiiresakiFlgDisp = m.shiiresakiFlg ? '○' : ''
    m.hacchusakiFlgDisp = m.hacchusakiFlg ? '○' : ''
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.torihikisakiCd > b.torihikisakiCd) { return 1 }
    if (a.torihikisakiCd === b.torihikisakiCd) { return 0 }
    return -1
  })
}

export const vwCMstTorihikisakiGetSeikyusaki = (state) => {
  return state.vwcmsttorihikisakigetseikyusaki.map((m) => {
    m.tokuisakiFlgDisp = m.tokuisakiFlg ? '○' : ''
    m.shiiresakiFlgDisp = m.shiiresakiFlg ? '○' : ''
    m.hacchusakiFlgDisp = m.hacchusakiFlg ? '○' : ''
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.torihikisakiCd > b.torihikisakiCd) { return 1 }
    if (a.torihikisakiCd === b.torihikisakiCd) { return 0 }
    return -1
  })
}

export const msysSystemConfig = (state) => {
  return state.msyssystemconfig
}

export const vwCMstKengenGroup01 = (state) => {
  return state.vwcmstkengengroup01
}

export const mstJishaGinkoKoza = (state) => {
  return state.mstjishaginkokoza.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.kinyuKikanCd > b.kinyuKikanCd) { return 1 }
    if (a.kinyuKikanCd === b.kinyuKikanCd) { return 0 }
    return -1
  })
}

export const mstTokuisaki = (state) => {
  return state.msttokuisaki.map((m) => {
    return m
  })
}

export const mstEigyosho = (state) => {
  return state.msteigyosho.map((m) => {
    // m.unyuKbnNm = ![undefined, null, ''].includes(m.unyuKbn) ? indexeddb.getKubun(m.kaishaCd, state.msyskubun, 'SFF063', m.unyuKbn).codeNm : ''
    // m.chiikiSbtNm = ![undefined, null, ''].includes(m.chiikiSbt) ? indexeddb.getShubetsu(m.kaishaCd, state.mstshubetsu, 'GVI001', m.chiikiSbt).sbtNm : ''
    // m.chikuSbtNm = ![undefined, null, ''].includes(m.chikuSbt) ? indexeddb.getShubetsu(m.kaishaCd, state.mstshubetsu, 'GVI002', m.chikuSbt).sbtNm : ''
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.eigyoshoCd > b.eigyoshoCd) { return 1 }
    if (a.eigyoshoCd === b.eigyoshoCd) { return 0 }
    return -1
  })
}

export const mstHinmei = (state) => {
  return state.msthinmei.map((m) => {
    if (![undefined, null, ''].includes(m.unitKbn)) {
      var p1 = indexeddb.getShubetsu(m.kaishaCd, state.mstshubetsu, 'SVI001', m.unitKbn)
      m.unitKbnNm = p1 ? p1.sbtNm : ''
    } else {
      m.unitKbnNm = ''
    }
    if (![undefined, null, ''].includes(m.unchinKeisanKbn)) {
      var p2 = indexeddb.getKubun(m.kaishaCd, state.msyskubun, 'SFF055', m.unchinKeisanKbn)
      m.unchinKeisanKbnNm = p2 ? p2.codeNm : ''
    } else {
      m.unchinKeisanKbnNm = ''
    }
    if (![undefined, null, ''].includes(m.hacchusakiUnchinKeisanKbn)) {
      var p3 = indexeddb.getKubun(m.kaishaCd, state.msyskubun, 'SFF087', m.hacchusakiUnchinKeisanKbn)
      m.hacchusakiUnchinKeisanKbnNm = p3 ? p3.codeNm : ''
    } else {
      m.hacchusakiUnchinKeisanKbnNm = ''
    }
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.hinmeiCd > b.hinmeiCd) { return 1 }
    if (a.hinmeiCd === b.hinmeiCd) { return 0 }
    return -1
  })
}

export const mstKingaku = (state) => {
  return state.mstkingaku
}

export const mstSharyo = (state) => {
  return state.mstsharyo.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.sharyoCd > b.sharyoCd) { return 1 }
    if (a.sharyoCd === b.sharyoCd) { return 0 }
    return -1
  })
}

export const mstShubetsu = (state) => {
  return state.mstshubetsu.map((m) => {
    return m
  }).filter(function (m) {
    return m.hyojiFlg === true
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.sbtShuruiCd > b.sbtShuruiCd) { return 1 }
    if (a.sbtShuruiCd === b.sbtShuruiCd) { return 0 }
    return -1
  })
}

export const mstJinin = (state) => {
  return state.mstjinin.map((m) => {
    m.jomuFlgDisp = m.jomuFlg ? '乗務員' : ''
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.jininCd > b.jininCd) { return 1 }
    if (a.jininCd === b.jininCd) { return 0 }
    return -1
  })
}

export const mstMenkyosho = (state) => {
  return state.mstmenkyosho.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.jininCd > b.jininCd) { return 1 }
    if (a.jininCd === b.jininCd) { return 0 }
    return -1
  })
}

export const mstTorihikisaki = (state) => {
  return state.msttorihikisaki.map((m) => {
    m.tokuisakiFlgDisp = m.tokuisakiFlg ? '○' : ''
    m.shiiresakiFlgDisp = m.shiiresakiFlg ? '○' : ''
    m.hacchusakiFlgDisp = m.hacchusakiFlg ? '○' : ''
    // m.chiikiSbtNm = m.chiikiSbt ? indexeddb.getShubetsu(m.kaishaCd, state.mstshubetsu, 'GVI001', m.chiikiSbt).sbtNm : ''
    // m.chikuSbtNm = m.chikuSbt ? indexeddb.getShubetsu(m.kaishaCd, state.mstshubetsu, 'GVI002', m.chikuSbt).sbtNm : ''
    // m.torihikisakiBunruiKbn1Nm = m.torihikisakiBunruiKbn1 ? indexeddb.getShubetsu(m.kaishaCd, state.mstshubetsu, 'SBT002', m.torihikisakiBunruiKbn1).sbtNm : ''
    // m.torihikisakiBunruiKbn2Nm = m.torihikisakiBunruiKbn2 ? indexeddb.getShubetsu(m.kaishaCd, state.mstshubetsu, 'SBT003', m.torihikisakiBunruiKbn2).sbtNm : ''
    // m.torihikisakiBunruiKbn3Nm = m.torihikisakiBunruiKbn3 ? indexeddb.getShubetsu(m.kaishaCd, state.mstshubetsu, 'SBT004', m.torihikisakiBunruiKbn3).sbtNm : ''
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.torihikisakiCd > b.torihikisakiCd) { return 1 }
    if (a.torihikisakiCd === b.torihikisakiCd) { return 0 }
    return -1
  })
}

export const msysKubun = (state) => {
  return state.msyskubun.map((m) => {
    return m
  }).filter(function (m) {
    return m.hyojiFlg === true && m.delFlg === false
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.kbnShuruiCd > b.kbnShuruiCd) { return 1 }
    if (a.kbnShuruiCd === b.kbnShuruiCd) { return 0 }
    return -1
  })
}

export const msysKubunShubetsuShurui = (state) => {
  return state.msyskubunshubetsushurui.map((m) => {
    return m
  }).filter(function (m) {
    return m.hyojiFlg === true && m.delFlg === false
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.kbnSbtShuruiCd > b.kbnSbtShuruiCd) { return 1 }
    if (a.kbnSbtShuruiCd === b.kbnSbtShuruiCd) { return 0 }
    return -1
  })
}

export const mstHacchakuchi = (state) => {
  return state.msthacchakuchi.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    return 0
  })
}

export const mstKihonJoho = (state) => {
  return state.mstkihonjoho
}

export const msysMessage = (state) => {
  return state.msysmessage
}

export const image = (state) => {
  return state.mstfaseimage ? state.mstfaseimage.faceImage : ''
}

export const msysMenu = (state) => {
  return state.msysmenu
}

export const msysMenuDetail = (state) => {
  return state.msysmenudetail
}

export const mstKengenGroup = (state) => {
  return state.mstkengengroup
}

export const msysKino = (state) => {
  return state.msyskino
}

export const msysGamenSeni = (state) => {
  return state.msysgamenseni
}

export const mstNyukinsaki = (state) => {
  return state.mstnyukinsaki.map((m) => {
    return m
  })
}

export const mstHacchusaki = (state) => {
  return state.msthacchusaki.map((m) => {
    return m
  })
}

export const mstSeikyusaki = (state) => {
  return state.mstseikyusaki.map((m) => {
    return m
  })
}

export const mstShiharaisaki = (state) => {
  return state.mstshiharaisaki.map((m) => {
    return m
  })
}

export const mstAddress = (state) => {
  return state.mstaddress
}

export const msysMenuOshirase = (state) => {
  return state.msysmenuoshirase
}

export const mstFileFormatKihon = (state) => {
  return state.mstfileformatkihon.map((m) => {
    return m
  }).filter(function (m) {
    return m.hyojiFlg === true
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    return 0
  })
}

export const vwCMstEigyoshoJininList = (state) => {
  return state.vwcmsteigyoshojininlist.map((m) => {
    m.jomuFlgDisp = m.jomuFlg ? '○' : ''
    m.seinengappi = m.seinengappi ? filter.dateFormatter(m.seinengappi) : ''
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.jininCd > b.jininCd) { return 1 }
    if (a.jininCd === b.jininCd) { return 0 }
    return -1
  })
}

export const vwCMstSharyo = (state) => {
  return state.vwcmstsharyo.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.sharyoCd > b.sharyoCd) { return 1 }
    if (a.sharyoCd === b.sharyoCd) { return 0 }
    return -1
  })
}

export const mstHaishahyo = (state) => {
  return state.msthaishahyo.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.haishahyoCd > b.haishahyoCd) { return 1 }
    if (a.haishahyoCd === b.haishahyoCd) { return 0 }
    return -1
  })
}

export const vwCMstHaishahyoSharyo = (state) => {
  return state.vwcmsthaishahyosharyo.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.haishahyoCd > b.haishahyoCd) { return 1 }
    if (a.haishahyoCd === b.haishahyoCd) { return 0 }
    return -1
  })
}

export const vwCD2mstd0370 = (state) => {
  return state.vwcd2mstd0370.map((m) => {
    return m
  })
}

export const vwCD2mstd0460 = (state) => {
  return state.vwcd2mstd0460.map((m) => {
    return m
  })
}

export const mstNenpiCategory = (state) => {
  console.log('mstNenpiCategory')
  return state.mstnenpicategory.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    return 0
  })
}

export const menuList = (state) => {
  const kengenList = state.vwcmstkengengroup.filter((k) => {
    return k.kengenValue >= 50
  })
  var menuDatilList = state.msysmenudetail
  var kengenMenuList = []
  for (let i = 0; i < menuDatilList.length; i++) {
    if (kengenList.find(elem => elem.mstKinoId === menuDatilList[i].mstKinoId)) {
      if (kengenMenuList.length > 0) {
        kengenMenuList.push(menuDatilList[i])
      } else {
        kengenMenuList = [menuDatilList[i]]
      }
    }
  }
  const result = state.msysmenu.map((m) => {
    m.lists = kengenMenuList.filter((d) => {
      return d.mstMenuId === m.id && d.hyojiFlg === true
    }).map((d) => {
      const kino = state.msyskino.find((k) => {
        return d.mstKinoId === k.id
      })
      d.kinoNm = kino.kinoNm
      d.viewNm = kino.viewNm
      d.kinoTitle = kino.kinoTitle
      d.kinoDescription = kino.kinoDescription
      d.oftenUseFlg = kino.oftenUseFlg
      return d
    }).sort((a, b) => {
      if (a.hyojiOrder < b.hyojiOrder) { return -1 }
      if (a.hyojiOrder > b.hyojiOrder) { return 1 }
      return 0
    })
    return m
  }).filter((m) => {
    return m.lists.length > 0
  }).sort((a, b) => {
    if (a.hyojiOrder < b.hyojiOrder) { return -1 }
    if (a.hyojiOrder > b.hyojiOrder) { return 1 }
    return 0
  })
  return result
}
export const mstShuhaiChiku = (state) => {
  return state.mstshuhaichiku.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.shuhaiChikuCd > b.shuhaiChikuCd) { return 1 }
    if (a.shuhaiChikuCd === b.shuhaiChikuCd) { return 0 }
    return -1
  })
}

export const mstBumon = (state) => {
  return state.mstbumon.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.bumonCd > b.bumonCd) { return 1 }
    if (a.bumonCd === b.bumonCd) { return 0 }
    return -1
  })
}

export const vwCMstChimei = (state) => {
  return state.vwcmstchimei.map((m) => {
    return m
  }).sort((a, b) => {
    if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
    if (a.ChimeiCd > b.ChimeiCd) { return 1 }
    if (a.ChimeiCd === b.ChimeiCd) { return 0 }
    return -1
  })
}

export const mstDigitakoJoho = (state) => {
  return state.mstdigitakojoho
}

export const mstEtcRiyouJoho = (state) => {
  return state.mstetcriyoujoho
}

export const mstUserSettings = (state) => {
  return state.mstusersettings
}
export const mstXlsImportMapping = (state) => {
  return state.mstxlsimportmapping
}
export const mstXlsTemplateKihon = (state) => {
  return state.mstxlstemplatekihon
}
export const helpUseFlg = (state) => {
  console.log('helpUseFlg', state)
  return (![undefined, null].includes(state.mstusersettings) && ![undefined, null].includes(state.mstusersettings.helpUseFlg)) ? state.mstusersettings.helpUseFlg : true
}
